import styled from "styled-components";

export const FundSummaryContainer = styled.div`
  display: flex;
  margin: ${props => props.theme.spacing.margins.webBase} 0
    ${props => props.theme.spacing.margins.webTwiceBase} 0;
  .ant-divider:last-child {
    display: none;
  }
  @media only screen and (max-width: 991px) {
    flex-direction: column;
  }
`;

export const FundSummaryContent = styled.div`
  margin-right: 101px;
  position: relative;
  &::after {
    content: "";
    height: 100%;
    width: 1px;
    position: absolute;
    right: -50px;
    background-color: #d4d4d4;
    top: 0;
  }
  &:last-child:after {
    display: none;
    margin-bottom: 0;
  }
  @media only screen and (max-width: 991px) {
    display: ${props => (props.identifier ? "flex" : "block")};
    justify-content: space-between;
    align-items: center;
    padding-bottom: 0.5rem;
    margin-right: 0;
    margin-bottom: 10px;
    &:last-child {
      padding-bottom: 0;
      margin-bottom: 0;
    }
    &::after {
      content: "";
      height: 1px;
      width: 100%;
      position: absolute;
      right: 0;
      margin-right: 0;
      background-color: ${props => props.theme.backgroundColor.summaryDivider};
      top: 100%;
    }
  }
`;
